export default function Text({ children, ...rest }) {
  return <p {...rest}>{children}</p>;
}
